import axios from 'axios'
import AuthToken from '@/auth/auth-token'

class Price {
  constructor () {
    const price = axios.create({
      baseURL: process.env.BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    price.interceptors.response.use(this.handleSuccess)
    this.price = price
  }

  handleSuccess (response) {
    let data = response.data
    return data
  }

  async getPrices (offset = 0, limit = 50, params = {}) {
    await AuthToken.setAuth(this.price)
    return this.price({
      url: '/prices',
      method: 'GET',
      params: { offset, limit, ...params }
    })
  }

  async get (id) {
    await AuthToken.setAuth(this.price)
    return this.price({
      url: `/price/${id}`,
      method: 'GET'
    })
  }

  async getPriceHistory (data, params = { limit: 50, offset: 0 }) {
    await AuthToken.setAuth(this.price)
    return this.price({
      url: `/price_history`,
      method: 'POST',
      data,
      params
    })
  }
}

export default new Price()


// WEBPACK FOOTER //
// ./src/api/price.js